const UserService = (() => {
	// private var(s)
    const _addressId = ""

	// private method(s)
	const _constructor = () => {
	};

	_constructor();

	// output/public
	return {
        addressId: _addressId,
	};
})();